/**
* @name: search-user-panel-body
* @author: weiyong
* @date: 2023-02-21 16:59
* @description：search-user-panel-body
* @update: 2023-02-21 16:59
*/
<template>
  <div class="search-user-panel-body">
   <div class="user-item-record" :key="index" v-for="(item,index) in searchUserList">
     <template v-if="item.showFlag!==false">
       <user-show-item
           @selItemRecord="selItemRecord"
           :hasCheck="true"
           :item="item"
           :remark="item.deptName+'-'+item.roleName"
           :icon="item.avatar"
           :value="item.id"
           :label="item.realName"/>
     </template>
   </div>
  </div>
 <div class="role-pagin">
   <a-pagination
       size="small"
       v-model:current="current1"
       v-model:pageSize="curPageSize"
       show-size-changer
       :total="total"
       :show-total="total => `总数 ${total} 条`"
       @showSizeChange="onShowSizeChange"
   />
 </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "search-user-panel-body",
});
</script>

<script lang="ts" setup>
import UserShowItem from "../components/user-show-item.vue";
import {Pagination as APagination} from 'ant-design-vue'
const emits=defineEmits(['selItemRecord','onShowSizeChange']);
const current1=ref(1);
const curPageSize:any=ref(20);
let suppressPageEmit = false;
const onShowSizeChange = (current: number, pageSize: number) => {
  emits('onShowSizeChange',{current, pageSizeNum:pageSize})
  curPageSize.value=pageSize;
};
watch(current1, (newVal) => {
  if (suppressPageEmit) {
    return;
  }
  onShowSizeChange(newVal,unref(curPageSize))
});
interface propTypes{
  pageSize:number;
  total:number;
  current?:number;
  alreadySelUsers:any;
  searchUserList:any
}
const props=withDefaults(defineProps<propTypes>(),{
  pageSize:20,
  total:0,
  current:1,
  alreadySelUsers:[],
  searchUserList:{}
})

const {pageSize, current}=toRefs(props);
curPageSize.value=unref(pageSize);
watch(current, (val) => {
  if (val != null && val !== unref(current1)) {
    suppressPageEmit = true;
    current1.value = val;
    nextTick(() => {
      suppressPageEmit = false;
    });
  }
}, { immediate: true });

const {searchUserList,alreadySelUsers}=toRefs(props);

const selAll=function (){
  unref(searchUserList).forEach((itemDb)=>{
    const selItemIndex  = unref(alreadySelUsers).findIndex((itemObj)=>{
      return itemObj.id===itemDb.id;
    })
    if(selItemIndex<0){
      unref(itemDb).check =true;
      emits('selItemRecord',{item:itemDb});
    }
  })
}

const selNotAll=function (){
  unref(searchUserList).forEach((itemDb)=>{
    const selItemIndex  = unref(alreadySelUsers).findIndex((itemObj)=>{
      return itemObj.id===itemDb.id;
    })
    if(selItemIndex>=0){
      unref(itemDb).check =false;
      emits('selItemRecord',{item:itemDb});
    }
  })
}


/**
 * 选择记录
 */
const selItemRecord=function ({item}){
  emits('selItemRecord',{item});
}
defineExpose({selAll,selNotAll})
</script>

<style type="text/css" lang="less">
.search-user-panel-body{
  height: calc(100% - 48px);
  overflow: auto;
}
.user-item-record{
  width: 100%;
}
.role-pagin{
  position: relative;
  top:12px;
  display: flex;
  justify-content: end;
  padding-right: 12px;
}
</style>
